import script from "./TellerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TellerPage.vue?vue&type=script&setup=true&lang=js"

import "./TellerPage.vue?vue&type=style&index=0&id=018d9306&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-018d9306"]])

export default __exports__